export default "__VITE_ASSET__CgBam0Aw__ 67w";